import { useFeatureGate } from '@statsig/react-bindings';
import { useAtomValue } from 'jotai';

import { telehealthMeetingGridLayoutGate } from '../../statsig/gates';
import { remoteParticipantsWithMediaMetadataAtom } from '../../video-sdk/core/room/participant/media/atoms';
import { RemoteParticipantGrid } from './RemoteParticipantGrid';
import type { RemoteParticipantGridProps } from './RemoteParticipantGrid';
import { RemoteParticipantGridLegacyWrapper } from './RemoteParticipantGridLegacy';

export type RemoteParticipantGridWrapperProps = Pick<RemoteParticipantGridProps, 'remoteParticipantComponent'>;

/**
 * Temporary. Inline this component after launching the feature gate.
 */
function RemoteParticipantGridWrapper_({
  remoteParticipantComponent: RemoteParticipantComponent,
}: RemoteParticipantGridWrapperProps) {
  const participants = useAtomValue(remoteParticipantsWithMediaMetadataAtom);

  return (
    <RemoteParticipantGrid remoteParticipants={participants} remoteParticipantComponent={RemoteParticipantComponent} />
  );
}

/**
 * Picks between the smart meeting grid layout and the
 * {@link RemoteParticipantGridLegacy} CSS grid based on the
 * {@link telehealthMeetingGridLayoutGate} feature gate.
 */
export function RemoteParticipantGridWrapper({ remoteParticipantComponent }: RemoteParticipantGridWrapperProps) {
  const { value: isMeetingGridLayoutEnabled } = useFeatureGate(telehealthMeetingGridLayoutGate);

  return isMeetingGridLayoutEnabled ? (
    <RemoteParticipantGridWrapper_ remoteParticipantComponent={remoteParticipantComponent} />
  ) : (
    <RemoteParticipantGridLegacyWrapper remoteParticipantComponent={remoteParticipantComponent} />
  );
}
